/* eslint-disable */

import { motion } from "framer-motion";

const Particle = () => {
  const randomXIntial = -200 + Math.random() * (window.innerWidth + 200);
  const randomYIntial = 0 - Math.random() * window.innerHeight * 2 - 100;

  const randomX = randomXIntial + (Math.random() - 0.5) * 30;
  const randomY = -10 + Math.random() * -30;

  const colorIndex = Math.floor(Math.random() * 3);
  const colors = ["#EF5FA7", "#EF5FA7", "#FFFFFF"];
  const color = colors[colorIndex];
  const size = Math.random() * 7 + 8;

  const speed = 16 + Math.random() * 4;
  const initialOpacity = 0.6 + Math.random() * 0.4;

  return (
    <motion.div
      className={`absolute rounded-full -z-10 h-full w-full`}
      style={{
        backgroundColor: color,
        width: size,
        height: size,
      }}
      initial={{
        opacity: initialOpacity,
        y: randomYIntial,
        x: randomXIntial,
      }}
      animate={{
        opacity: 0,
        y: 2 * window.innerHeight,
        x: randomX,
      }}
      transition={{
        duration: speed,
        ease: "easeOut",
        repeatDelay: 0,
      }}
    />
  );
};

const RaindropSparkleCurtain = () => {
  const particles = Array(200).fill(0);

  return (
    <div className="absolute overflow-visible flex flex-col w-full h-full pointer-events-none">
      {particles.map((_, i) => (
        <Particle key={i} />
      ))}
    </div>
  );
};

export default RaindropSparkleCurtain;
